<template>
	<div class="current-table">
		<div class="summary-notice">集計期間：過去1ヵ月</div>
		<table class="bold18">
			<thead>
				<tr>
					<th><img :src="require('@/assets/icons/crown_gold.svg')"/></th>
					<th>コイン数</th>
					<th>順位</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th>獲得</th>
					<td><span class="current-number">{{ data.recieve_total }}</span>枚</td>
					<td><span class="current-number">{{ data.recieve_rank }}</span>位<span class="total-suffix">／{{ data.recieve_rank_total + totalSuffix  }}</span></td>
				</tr>
				<tr>
					<th>贈呈</th>
					<td><span class="current-number">{{ data.present_total }}</span>枚</td>
					<td><span class="current-number">{{ data.present_rank }}</span>位<span class="total-suffix">／{{ data.present_rank_total + totalSuffix  }}</span></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>

export default {
	name: 'CurrentTable',
	props: {
		data: {
			type: Object,
			default: null,
		},
		isTeam: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
		totalSuffix: function() {
			return !this.isTeam ? '人中' : 'チーム中';
		},
	},
	methods: {
	},
}
</script>

<style lang="scss">
@import '@/scss/_vars.scss';

table {
	width: 100%;
	margin: 0 auto;
}

th,td {
	text-align: center !important;
	border: $commonBorder;
	padding: 2px 0;
}

td {
	min-width: 130px;
}

tr + th {
	width: 50px;
}
.current-number {
	color: $red;
	margin-right: 5px;
}
.total-suffix {
	font-size: 12px;
}

</style>
